<template>
    <div class="main-feed pt-10 ml-5 mr-5" v-bind:style="{'zoom': '80%'}">
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate color="orange"
                                 :size="70" :width="7"></v-progress-circular>
        </v-overlay>
        <div>
            <v-row>
                <v-alert v-if="errorMessage" width="100%" class="mr-5 ml-5" v-model="isError" dismissible type="error"> {{ errorMessage }}</v-alert>
            </v-row>
            <v-row>
                <v-col cols="5">
                    <v-card v-if="(!!calculatedCertificates || dogCertsInDB) && !!showResults">
                        <v-card-title>
                            {{title}}
                            <v-spacer />
                            <v-btn width="120px"
                                   color="primary"
                                   v-on:click="clearFilters">
                                Clear filters
                            </v-btn>&nbsp;
                            <v-btn outlined color="primary"
                                   v-on:click="csvExport(2)">
                                <font-awesome-icon icon="file-download" size="lg" />
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field outlined dense clearable
                                                  v-model="dogId"
                                                  label="Dog id" />
                                </v-col>
                                <v-col cols="4">
                                    <v-select dense outlined clearable
                                              :items="['Rally', 'Obedience', 'Agility', 'Stock', 'Conformation', 'Tracking', 'Farm Trial', 'Ranch Trial', 'Specialty', 'Scent Detection','Dock Jumping']"
                                              v-model="titleKey" />
                                </v-col>
                                <v-spacer />
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                    <v-row dense>

                                        DB: {{dogName}}

                                    </v-row>
                                    <v-row dense>

                                        C#: {{generatedDogName}}

                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="ma-0 pa-0">
                                <v-col class="pt-0">
                                    <v-container fluid v-if="selectedCategory == 'A'">
                                        <v-row dense>
                                            <v-col>
                                                <v-card v-if="!!currentATCHprogressionStatus && !!(currentATCHprogressionStatus.regular || currentATCHprogressionStatus.gamblers || currentATCHprogressionStatus.jumpers)">
                                                    <v-card-title>
                                                        Working on {{currentATCHprogressionStatus.title}}
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table>
                                                            <tr>
                                                                <td><b>Regular:</b></td>
                                                                <td>{{currentATCHprogressionStatus.regular}}</td>
                                                                <td class="pl-2"><b>Gamblers:</b></td>
                                                                <td class="pl-2">{{currentATCHprogressionStatus.gamblers}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Jumpers:</b></td>
                                                                <td>{{currentATCHprogressionStatus.jumpers}}</td>
                                                                <td class="pl-2"></td>
                                                                <td class="pl-2"></td>
                                                            </tr>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col>
                                                <v-card v-if="!!currentACEprogressionStatus && !!(currentACEprogressionStatus.regular || currentACEprogressionStatus.gamblers || currentACEprogressionStatus.jumpers)">
                                                    <v-card-title>Working on {{currentACEprogressionStatus.title}}</v-card-title>
                                                    <v-card-text>
                                                        <table>
                                                            <tr>
                                                                <td><b>Regular:</b></td>
                                                                <td>{{currentACEprogressionStatus.regular}}</td>
                                                                <td class="pl-2"><b>Gamblers:</b></td>
                                                                <td class="pl-2">{{currentACEprogressionStatus.gamblers}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Jumpers:</b></td>
                                                                <td>{{currentACEprogressionStatus.jumpers}}</td>
                                                                <td class="pl-2"></td>
                                                                <td class="pl-2"></td>
                                                            </tr>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col>
                                                <v-card v-if="selectedCategory == 'A'">
                                                    <v-card-title>
                                                        CH to ACE transfer
                                                        <v-spacer />
                                                        <a v-on:click="highlightUnusedAgilityPoints=!highlightUnusedAgilityPoints">
                                                            Toggle highlight
                                                        </a>
                                                    </v-card-title>
                                                    <v-card-text :style="{ display: 'flex', gap: '4px',  'flex-wrap': 'wrap'}">
                                                        <v-btn color="primary"
                                                               :disabled="selectedCategory != 'A'"
                                                               v-on:click="transferToACE">
                                                            Transfer to ACE
                                                        </v-btn><br />
                                                        <v-btn color="primary"
                                                               :disabled="selectedCategory != 'A'"
                                                               v-on:click="revertTransferToACE">
                                                            Clear all transfers
                                                        </v-btn>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                          
                                        </v-row>
                                    </v-container>
                                    <v-container v-if="!!currentRTCHprogressionStatus && !!currentRTCHprogressionStatus.title">
                                        <v-row class="ma-0 pa-0">
                                            <v-col>
                                                <v-card>
                                                    <v-card-title>
                                                        Working on {{currentRTCHprogressionStatus.title}}
                                                        <v-spacer />
                                                        <a v-if="!!currentRTCHprogressionStatus && currentRTCHprogressionStatus.relatedResultsIds" v-on:click="highlightRTCHresults=!highlightRTCHresults">
                                                            Toggle highlight
                                                        </a>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table>
                                                            <tr>
                                                                <td><b>Excellent points total:</b></td>
                                                                <td>{{currentRTCHprogressionStatus.excellentTotalPoints}}</td>
                                                                <td class="pl-2"><b>Master points total:</b></td>
                                                                <td class="pl-2">{{currentRTCHprogressionStatus.masterTotalPoints}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Excellent 195 scores:</b></td>
                                                                <td>{{currentRTCHprogressionStatus.excellent195ScoresCount}} from {{currentRTCHprogressionStatus.excellent195ScoresJudgesCount}} judges</td>
                                                                <td class="pl-2"><b>Master 195 scores:</b></td>
                                                                <td class="pl-2">{{currentRTCHprogressionStatus.master195ScoresCount}} from {{currentRTCHprogressionStatus.master195ScoresJudgesCount}} judges</td>
                                                            </tr>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    
                                    <v-container v-if="selectedCategory == 'O'">
                                        <v-row class="ma-0 pa-0" v-if="!!currentOTCHprogressionStatus && !!currentOTCHprogressionStatus.title && currentOTCHprogressionStatus.totalPoints > 0">
                                            <v-col>
                                                <v-card>
                                                    <v-card-title>
                                                        Working on {{currentOTCHprogressionStatus.title}}
                                                        <v-spacer />
                                                        <a v-if="!!currentOTCHprogressionStatus && currentOTCHprogressionStatus.relatedResultsIds" v-on:click="highlightOTCHresults=!highlightOTCHresults">
                                                            Toggle highlight
                                                        </a>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table>
                                                            <tr>
                                                                <td class="pl-2"><b>Points total:</b></td>
                                                                <td class="pl-2">{{currentOTCHprogressionStatus.totalPoints}}</td>
                                                            </tr>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <v-row class="ma-0 pa-0" v-if="!!currentOTCHOprogressionStatus && !!currentOTCHOprogressionStatus.title && currentOTCHOprogressionStatus.totalPoints > 0">
                                            <v-col>
                                                <v-card>
                                                    <v-card-title>
                                                        Working on {{currentOTCHOprogressionStatus.title}}
                                                        <v-spacer />
                                                        <a v-if="!!currentOTCHOprogressionStatus && currentOTCHOprogressionStatus.relatedResultsIds" v-on:click="highlightOTCHOresults=!highlightOTCHOresults">
                                                            Toggle highlight
                                                        </a>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <table>
                                                            <tr>
                                                                <td class="pl-2"><b>Points total:</b></td>
                                                                <td class="pl-2">{{currentOTCHOprogressionStatus.totalPoints}}</td>
                                                            </tr>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    <v-container fluid v-if="selectedCategory == 'O'">
                                        <v-row dense>
                                            <v-col>
                                                <v-card>
                                                    <v-card-title>
                                                        Unassigned Utility Results
                                                        <v-spacer />
                                                        <a v-on:click="highlightUnappliedUDResults=!highlightUnappliedUDResults">
                                                            Toggle highlight
                                                        </a>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <v-btn color="primary"
                                                               :disabled="selectedCategory != 'O'"
                                                               v-on:click="applyObedienceUtilitiesToTitle('OTCH')">
                                                            Apply To OTCH
                                                        </v-btn> &nbsp;&nbsp;
                                                        <v-btn color="primary"
                                                               :disabled="selectedCategory != 'O'"
                                                               v-on:click="applyObedienceUtilitiesToTitle('OTCH-O')">
                                                            Apply to OTCH-O
                                                        </v-btn>
                                                        &nbsp;&nbsp;
                                                        <v-btn color="primary"
                                                               :disabled="selectedCategory != 'O'"
                                                               v-on:click="applyObedienceUtilitiesToTitle('')">
                                                            Remove All
                                                        </v-btn>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        
                                    </v-container>
                                    <v-container v-if="!!currentScchProgressionStatus && !!currentScchProgressionStatus.pointsTotal">
                                        <v-row class="ma-0 pa-0">
                                            <v-col>
                                                <v-card>
                                                    <v-card-title>
                                                        Working on {{ currentScchProgressionStatus.nextTitle}}  
                                                        <v-spacer />
                                                        <a v-if="!!currentScchProgressionStatus && currentScchProgressionStatus.majorWinsShowResultsIds" v-on:click="highlightScchMajorWins=!highlightScchMajorWins">
                                                            Toggle highlight major wins
                                                        </a>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <p>
                                                            <span><b>Points total: </b>{{currentScchProgressionStatus.pointsTotal}}
                                                            ({{currentScchProgressionStatus.majorWinsCount}} <b>major wins</b> from {{currentScchProgressionStatus.majorWinsJudgesCount}} <b>different judges</b> 
                                                                and remaining scores from {{currentScchProgressionStatus.otherScoresJudgesCount}} <b>other judges</b>)</span><br/>                                                            
                                                        </p>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-data-table :headers="certificatesHeaders"
                                                  :items="certificatesList"
                                                  style="font-size:9pt"
                                                  dense
                                                  hide-default-footer
                                                  :items-per-page="-1"
                                                  :height="(!!currentATCHprogressionStatus || !!currentACEprogressionStatus || !!currentRTCHprogressionStatus) ? '75vh' : '93vh'"
                                                  fixed-header>
                                        <template v-slot:item.finalShowDate="{ item }">
                                            <span :class="!areDatesEqual(item.dbShowDate, item.finalShowDate) ? 'red--text text--darken-4 orange  lighten-4' : ''">
                                                <span v-if="item.finalShowDate">
                                                    <localized-date :date="item.finalShowDate" />
                                                </span>
                                                <span v-else>
                                                    Missing
                                                </span>
                                            </span>
                                        </template>
                                        <template v-slot:item.dbShowDate="{ item }">
                                            <span>
                                                <span v-if="item.dbShowDate"
                                                      :class="!areDatesEqual(item.dbShowDate, item.finalShowDate) ? 'red--text text--darken-4 orange  lighten-4' : ''">
                                                    <localized-date :date="item.dbShowDate" />
                                                </span>
                                                <span v-else>
                                                    ---
                                                </span>
                                            </span>
                                        </template>
                                        <template v-slot:item.genDate="{ item }">
                                            <span>
                                                <span v-if="item.genDate"
                                                      :class="!areDatesEqual(item.dbShowDate, item.finalShowDate) ? 'red--text text--darken-4 orange  lighten-4' : ''">
                                                    <localized-date :date="instantToLocalDate(item.genDate)" />
                                                </span>
                                                <span v-else>
                                                    ---
                                                </span>
                                            </span>
                                        </template>
                                        <template v-slot:item.printDate="{ item }">
                                            <span>
                                                <span v-if="item.printDate"
                                                      :class="!areDatesEqual(item.dbShowDate, item.finalShowDate) ? 'red--text text--darken-4 orange  lighten-4' : ''">
                                                    <localized-date :date="instantToLocalDate(item.printDate)" />
                                                </span>
                                                <span v-else>
                                                    ---
                                                </span>
                                            </span>
                                        </template>
                                        <template v-slot:item.titleName="{ item }">
                                            <v-chip small pill :color="getTitleColor(item.titleName, item.title)" dark>
                                                {{ item.titleName }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.relatedResultsIds="{ item }">
                                            <a v-if="item.relatedResultsIds" v-on:click="filterResults(item.title, item.relatedResultsIds)">Filter</a>
                                            <a v-if="item.relatedCertIds" v-on:click="filterCertificates(item.title, item.relatedCertIds)">Filter</a>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-col>
                <v-col cols="7">
                    <v-card>
                        <v-card-title>
                            <v-text-field v-model="search"
                                          append-icon="mdi-magnify"
                                          label="Search"
                                          class="ml-1"
                                          single-line
                                          hide-details
                                          clearable>
                            </v-text-field>
                            <v-btn outlined color="primary"
                                   v-on:click="csvExport(1)">
                                <font-awesome-icon icon="file-download" size="lg" />
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table v-if="this.selectedCategory != 'SP' && this.selectedCategory !='O'" :headers="showResultsHeaders" :items="filteredResults"
                                          :search="search"
                                          dense
                                          show-group-by
                                          :item-class="row_classes"
                                          :sort-by="['showDate', 'showId']"
                                          :sort-desc="[false, false]"
                                          multi-sort
                                          :items-per-page="-1"
                                          fixed-header
                                          :show-select="highlightUnusedAgilityPoints"
                                          v-model="resultsSelectedForTransfer"
                                          item-key="resultId"
                                          selectable-key="isSelectable"
                                          height="101vh">
                                <template v-slot:header.data-table-select="{ header }">
                                    <v-checkbox label="All"
                                                v-model="allSelected"
                                                :disabled="unusedSelected"
                                                class="ma-0 pa-0"></v-checkbox>
                                    <v-checkbox label="Unused"
                                                v-model="unusedSelected"
                                                :disabled="allSelected"
                                                class="ma-0 pa-0"></v-checkbox>
                                </template>

                                <template v-slot:item.showDate="{ item }">
                                    <localized-date :date="item.showDate" />
                                </template>
                                <template v-slot:item.enteredAt="{ item }">
                                    <localized-date :date="instantToLocalDate(item.enteredAt)" />
                                </template>
                                <template v-slot:item.distance="{ item }">
                                    <DistanceDisplay :value="item.distance" />
                                </template>
                                <template v-slot:item.showId="{ item }">
                                    <v-span>{{ item.resultId }}</v-span>
                                    <br/>                                    
                                    <router-link v-if="item.showId" :to="`/admin/shows/${item.showId}`" target="_blank">
                                        {{ item.showId }} 
                                    </router-link>
                                </template>
                                <template v-slot:item.score="{ item }">
                                    <span>{{ item.score }}</span>
                                    <br />
                                </template>
                                <template v-slot:item.resultId="{ item }">
                                    <v-chip class="mr-1" small v-for="(cert,idx) in getCertificatesForResult(item.resultId)" v-bind:key="idx"
                                            :color="getTitleColor(cert.name, cert.id)" dark>
                                        {{ cert.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item.transferredToAce="{ item }">
                                    <span v-if="item.transferredToAce">CH to ACE:</span>
                                    <span v-if="item.transferredToAce"><br />{{ item.transferredToAceScore ?  item.transferredToAceScore : item.score }}/{{ item.score }}</span>
                                    <span v-if="selectedCategory == 'A' && unusedAgilityPointsForTransfer && unusedAgilityPointsForTransfer.length > 0 && unusedAgilityPointsForTransfer.map((r) => r.resultId).includes(item.resultId)">
                                        Unused: {{ unusedAgilityPointsForTransfer.filter(r => r.resultId === item.resultId)[0].unusedPoints }}
                                    </span>
                                    <br />
                                </template>                                
                                <template v-slot:item.isScchMajor="{ item }">
                                    <span v-if="item.isScchMajor != null">
                                        {{ item.isScchMajor ? 'Yes' : 'No' }}
                                    </span>
                                    <span v-else></span>
                                </template>
                            </v-data-table>
                            <v-data-table v-if="this.selectedCategory == 'O'" :headers="showResultsHeaders" :items="filteredResults"
                                          :search="search"
                                          dense
                                          show-group-by
                                          :item-class="row_classes"
                                          :sort-by="['showDate', 'showId']"
                                          :sort-desc="[false, false]"
                                          multi-sort
                                          :items-per-page="-1"
                                          fixed-header
                                          :show-select="highlightUnappliedUDResults"
                                          v-model="resultsSelectedForTitlePath"
                                          item-key="resultId"
                                          selectable-key="isSelectable"
                                          height="101vh">
                                <template v-slot:header.data-table-select="{ header }">
                                    <v-checkbox label="All"
                                                v-model="allSelectedOb"
                                                :disabled="unappliedSelectedOb"
                                                class="ma-0 pa-0"></v-checkbox>
                                    <v-checkbox label="Unapplied"
                                                v-model="unappliedSelectedOb"
                                                :disabled="allSelectedOb"
                                                class="ma-0 pa-0"></v-checkbox>
                                </template>

                                <template v-slot:item.showDate="{ item }">
                                    <localized-date :date="item.showDate" />
                                </template>
                                <template v-slot:item.enteredAt="{ item }">
                                    <localized-date :date="instantToLocalDate(item.enteredAt)" />
                                </template>
                                <template v-slot:item.showId="{ item }">
                                    <v-span>{{ item.resultId }}</v-span>
                                    <br/>                                    
                                    <router-link v-if="item.showId" :to="`/admin/shows/${item.showId}`" target="_blank">
                                        {{ item.showId }} 
                                    </router-link>
                                </template>
                                <template v-slot:item.score="{ item }">
                                    <span>{{ item.score }}</span>
                                    <br />
                                </template>
                                <template v-slot:item.resultId="{ item }">
                                    <v-chip class="mr-1" small v-for="(cert,idx) in getCertificatesForResult(item.resultId)" v-bind:key="idx"
                                            :color="getTitleColor(cert.name, cert.id)" dark>
                                        {{ cert.name }}
                                    </v-chip>
                                </template>
                              
                            </v-data-table>
                            <v-data-table v-if="selectedCategory == 'SP'"
                                          :headers="sourceCertificatesHeaders"
                                          :items="filteredSourceCertificates"
                                          :search="search"
                                          style="font-size:9pt"
                                          dense
                                          show-group-by
                                          hide-default-footer
                                          :items-per-page="-1"
                                          :height="(!!currentATCHprogressionStatus || !!currentACEprogressionStatus || !!currentRTCHprogressionStatus) ? '75vh' : '93vh'"
                                          fixed-header>
                                <template v-slot:item.showDate="{ item }">
                                    <localized-date :date="item.showDate" />
                                </template>
                                <template v-slot:item.generatedAt="{ item }">
                                    <localized-date :date="instantToLocalDate(item.generatedAt)" />
                                </template>
                                <template v-slot:item.title="{ item }">
                                    <v-chip small pill :color="getTitleColor(item.title, item.title)" dark>
                                        {{ item.title }}
                                    </v-chip>
                                </template>
                                <template v-slot:item.id="{ item }">
                                    <v-chip class="mr-1" small v-for="(cert,idx) in getCertificatesForCertificate(item.id)" v-bind:key="idx"
                                            :color="getTitleColor(cert.name, cert.id)" dark>
                                        {{ cert.name }}
                                    </v-chip>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import adminTitlingService from "@/services/admin/titlingService";
    import { UserInfo } from "@/types/User";
    import { debounce } from "throttle-debounce";
    import { MetaNames } from "@/constants";
    import { getErrorMessage } from "@/services/errorHandler";
    import { areDatesEqual, instantToLocalDate } from "@/helpers/date-utils";
    import DistanceDisplay from "@/components/common/DistanceDisplay.vue";
    import { downloadCsv } from "@/helpers/download-csv";

    export default Vue.extend({
        name: "TitlingReview",
        props: {
            readyToApproveOnly: String,
            program: String,
            propsDogId: String
        },
        components: {
            DistanceDisplay,
        },
        data: function () {
            return {
                title: MetaNames.AdminTitlingReview,
                dogId: this.$props.propsDogId ?? null,
                allCertificates: [] as any[],
                calculatedCertificates: Array<object>(),
                filteredCertificates: Array<object>(),
                search: '',
                isLoading: false,
                loadRequestId: 0,
                loadSelectedDogReviewDebounced: null as any,
                filteredResults: [] as any[],
                highlightedResults: [] as any[],
                showResults: [] as any[],
                sourceCertificates: [] as any[],
                filteredSourceCertificates: [] as any[],
                highlightResults: false,
                certificatesHeaders: [
                    { text: "Title", align: "left", value: "titleName" },
                    { text: "DB Show Date", align: "left", value: "dbShowDate" },
                    { text: "Generated On", align: "left", value: "genDate" },
                    { text: "Printed On", align: "left", value: "printDate" },
                    { text: "Show ID", align: "left", value: "finalShowId" },
                    { text: "Show Date", align: "left", value: "finalShowDate" },
                    { text: "Filter", align: "left", value: "relatedResultsIds" },
                ],
                sourceCertificatesHeaders: [
                    { text: "Title", align: "left", value: "title" },
                    { text: "Number", align: "left", value: "certNumber" },
                    { text: "Show Date", align: "left", value: "showDate" },
                    { text: "Program", align: "left", value: "program" },
                    { text: "Generated On", align: "left", value: "generatedAt" },
                    { text: "Certificates", align: "left", value: "id", groupable: false },
                ],
                showResultsHeaders: [
                    { text: "Entry Date", align: "left", value: "enteredAt", width: "100px" },
                    { text: "Show Date", align: "left", value: "showDate", width: "100px" },
                    { text: "Result/Show ID", align: "left", value: "showId", width: "100px" },
                    { text: "Descr.", align: "left", value: "description", width: "100px" },
                    { text: "Distance", align: "left", value: "distance", width: "50px" },
                    { text: "Category", align: "left", value: "category", width: "50px" },
                    { text: "Division", align: "left", value: "division", width: "50px" },
                    { text: "Apply to", align: "left", value: "applyTo", width: "50px" },
                    { text: "Score", align: "left", value: "score", width: "50px" },
                    { text: "#cmp", align: "left", value: "nCompeting", width: "100px" },
                    { text: "SCCH Score", align: "left", value: "scchScore", width: "50px" },
                    { text: "SCCH Major", align: "left", value: "isScchMajor", width: "50px" },
                    { text: "Judge", align: "left", value: "judge" },
                    { text: "CH to ACE", align: "left", value: "transferredToAce" },
                    { text: "Certificates", align: "left", value: "resultId", groupable: false },
                    { text: "Handler", align: "left", value: "handler" },
                ],
                colors: [
                    "#e51c23", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#5677fc", "#03a9f4", "#00bcd4",
                    "#009688", "#259b24", "#8bc34a", "#afb42b", "#ff9800", "#ff5722", "#795548", "#607d8b",
                ],
                dogCertsInDB: [] as any[],
                selectedCategory: '',
                currentRTCHprogressionStatus: null as any,
                currentOTCHprogressionStatus: null as any,
                currentOTCHOprogressionStatus: null as any,
                currentATCHprogressionStatus: null as any,
                currentACEprogressionStatus: null as any,
                currentScchProgressionStatus: null as any,
                highlightRTCHresults: false,
                highlightOTCHresults: false,
                highlightOTCHOresults: false,
                highlightUnusedAgilityPoints: false,
                highlightScchMajorWins: false,
                titleKey: this.$props.program ?? null,
                dogName: "",
                generatedDogName: "",
                unusedAgilityPointsForTransfer: [] as any[],
                resultsSelectedForTransfer: [] as any[],
                allSelected: false,
                unusedSelected: false,
                errorMessage: '',
                isError: false,
                resultsSelectedForTitlePath: [] as any[],
                unappliedUtilityResults: [] as any[],
                highlightUnappliedUDResults: false,
                allSelectedOb: false,
                unappliedSelectedOb: false,
               
            };
        },        
        created() {
            this.loadSelectedDogReviewDebounced = debounce(1500, () => this.loadSelectedDogReview());
            if(this.$props.program && this.$props.propsDogId){
                this.loadTitlesSelect(this.$props.program);
            }
        },
        beforeDestroy() {
            this.loadSelectedDogReviewDebounced?.cancel();
        },
        methods: {
            areDatesEqual,
            instantToLocalDate,
            transferToACE(){
                this.$store.dispatch("changeLoaderStatus",true);
                var resultsSelectedForTransfer = this.resultsSelectedForTransfer.map(r => r.resultId);
                adminTitlingService.transferUnusedPointsToACE(this.dogId, this.unusedAgilityPointsForTransfer, resultsSelectedForTransfer).then((res) =>{
                    this.$store.dispatch("changeLoaderStatus",false);
                    this.loadTitlesSelect(this.$props.program);
                });
            },
            revertTransferToACE(){
                this.$store.dispatch("changeLoaderStatus",true);
                adminTitlingService.untransferUnusedPointsFromACE(this.dogId).then((res) =>{
                    this.$store.dispatch("changeLoaderStatus",false);
                    this.loadTitlesSelect(this.$props.program);
                });
            },
            row_classes(item: any) {
                if (this.selectedCategory == 'O') {
                    if (!this.highlightUnappliedUDResults && !this.highlightOTCHresults && !this.highlightOTCHOresults) {
                        return '';
                    }
                    if (this.highlightUnappliedUDResults && this.unappliedUtilityResults.map((r: any) => r.resultId).includes(item.resultId)) {
                        return 'orange  lighten-4';
                    }
                    if (this.highlightOTCHresults && this.currentOTCHprogressionStatus.relatedResultsIds.includes(item.resultId)) {
                        return 'orange  lighten-4';
                    }
                    if (this.highlightOTCHOresults && this.currentOTCHOprogressionStatus.relatedResultsIds.includes(item.resultId)) {
                        return 'orange  lighten-4';
                    }
                }
                else {
                    if (this.currentRTCHprogressionStatus && this.currentRTCHprogressionStatus.relatedResultsIds.includes(item.resultId)) {
                        return 'orange  lighten-4';
                    }
                    if (this.highlightUnusedAgilityPoints && this.unusedAgilityPointsForTransfer.map((r: any) => r.resultId).includes(item.resultId)) {
                        return 'orange  lighten-4';
                    }
                    if (this.highlightScchMajorWins && this.currentScchProgressionStatus.majorWinsShowResultsIds.includes(item.resultId)) {
                        return 'orange  lighten-4';
                    }
                    return '';
                }
                
            },
            getCertDBDate(selectedCert: string) {
                const cert = this.dogCertsInDB.find(({ title }) => title === selectedCert.toString());
                return cert ? cert.showDate : cert;
            },
            getCertGeneratedDBDate(selectedCert: string) {
                const cert = this.dogCertsInDB.find(({ title }) => title === selectedCert.toString());
                return cert ? cert.generatedAt : cert;
            },
            getCertPrintedDBDate(selectedCert: string) {
                const cert = this.dogCertsInDB.find(({ title }) => title === selectedCert.toString());
                return cert ? cert.printedAt : cert;
            },
            getCertificatesForResult(resultId: any) {
                var appliedInCerts = this.filteredCertificates.filter((cert: any) =>
                    cert.relatedResultsIds.includes(resultId)
                );
                var certsList = appliedInCerts.map((cert: any) => {
                    return { id: cert.title, name: cert.titleName };
                });
                return certsList;
            },
            getCertificatesForCertificate(id: any) {
                var appliedInCerts = this.filteredCertificates.filter((cert: any) =>
                    cert.relatedCertIds?.includes(id)
                );
                var certsList = appliedInCerts.map((cert: any) => {
                    return { id: cert.title, name: cert.titleName };
                });
                return certsList;
            },
            getTitleColor(titleName: string, titleId: number) {
                const text = `123${titleName}123`;//`${titleId}${titleName}${titleId}`
                var hash = 0;
                if (text.length === 0) return hash;
                for (var i = 0; i < text.length; i++) {
                    hash = text.charCodeAt(i) + ((hash << 3) - hash);
                    hash = hash & hash;
                }
                hash = ((hash % this.colors.length) + this.colors.length) % this.colors.length;
                return this.colors[hash];
            },
            loadtitles: function (titlesFunction: Function, selectedCategory: string) {
                const dogId = this.dogId;
                const requestId = ++this.loadRequestId;
                const isCurrentLoad = () => requestId === this.loadRequestId
                    && dogId === this.dogId
                    && selectedCategory === this.selectedCategory;
                this.selectedCategory = selectedCategory;
                this.dogCertsInDB = [];
                this.showResults = [];
                this.filteredResults = [];
                this.sourceCertificates = [];
                this.filteredSourceCertificates = [];
                this.calculatedCertificates = [];
                this.currentRTCHprogressionStatus = null;
                this.currentATCHprogressionStatus = null;
                this.currentACEprogressionStatus = null;
                this.currentOTCHprogressionStatus = null;
                this.currentOTCHOprogressionStatus = null;
                this.currentScchProgressionStatus = null;
                this.unusedAgilityPointsForTransfer = [];
                this.unappliedUtilityResults = [];

                var calculatingCerts = true;
                var loadingResults = true;
                var loadingCerts = true;

                this.isLoading = true;

                adminTitlingService
                    .getCertificatesForADog(dogId, selectedCategory)
                    .then((res) => {
                        if (!isCurrentLoad()) return;
                        this.dogCertsInDB = res;

                        loadingCerts = false;
                        if (!calculatingCerts && !loadingResults && !loadingCerts) {
                            this.isLoading = false;
                        }
                    
                        titlesFunction(dogId)
                            .then((res: any) => {
                                if (!isCurrentLoad()) return;
                                if(res.messages){
                                    this.errorMessage = res.messages.join(',');
                                    calculatingCerts = false;
                                    if (!calculatingCerts && !loadingResults && !loadingCerts) {
                                        this.isLoading = false;
                                    }
                                } else {
                                    this.errorMessage = ''
                                    this.calculatedCertificates = res.certs;
                                    if (res.rtcH_CurrentProgression) {
                                        this.currentRTCHprogressionStatus = res.rtcH_CurrentProgression;
                                    }
                                    if (res.atchStatus) {
                                        this.currentATCHprogressionStatus = res.atchStatus;
                                    }
                                    if (res.aceStatus) {
                                        this.currentACEprogressionStatus = res.aceStatus;
                                    }
                                    if (res.unusedPoints) {
                                        this.unusedAgilityPointsForTransfer = res.unusedPoints;
                                        const unusedResultIds = res.unusedPoints.map((r: any) => r.resultId);
                                        this.showResults.forEach(sr => {
                                            sr.canBetransferredToAce = unusedResultIds && unusedResultIds.includes(sr.resultId);
                                        });
                                    }
                                    if(res.otchProgression)
                                        this.currentOTCHprogressionStatus = res.otchProgression;
                                    if(res.otchoProgression)
                                        this.currentOTCHOprogressionStatus = res.otchoProgression;
                                   
                                    if(res.scchProgressionStatus)
                                        this.currentScchProgressionStatus = res.scchProgressionStatus;
                                        
                                    this.filteredCertificates = res.certs;

                                    calculatingCerts = false;
                                    if (!calculatingCerts && !loadingResults && !loadingCerts) {
                                        this.isLoading = false;
                                    }
                                }
                            })
                            .catch((e: any) => {
                                if (isCurrentLoad()) this.handleLoadFailure(e);
                            });
                    })
                    .catch((e: any) => {
                        if (isCurrentLoad()) this.handleLoadFailure(e);
                    });

                if(selectedCategory !== 'SP'){
                    adminTitlingService
                        .getShowResultsForADog(dogId, selectedCategory)
                        .then((res: any) => {
                            if (!isCurrentLoad()) return;
                            if (res.data == null) {
                                this.handleLoadFailure(new Error("Unable to load show results."));
                                return;
                            }

                            this.sourceCertificates = [];
                            this.filteredSourceCertificates = [];
                            this.showResults = res.data;
                            this.filteredResults = res.data;
                            if (this.selectedCategory == 'O') {
                                for (let i = 0; i < res.data.length; i++) {

                                    if (res.data[i].applyTo === '' && res.data[i].category.trim() == "UD") {

                                        this.unappliedUtilityResults.push(res.data[i]);

                                    }
                                }
                            }
                            loadingResults = false;
                            if (!calculatingCerts && !loadingResults && !loadingCerts) {
                                this.isLoading = false;
                            }
                        })
                        .catch((e: any) => {
                            if (isCurrentLoad()) this.handleLoadFailure(e);
                        });
                } else {
                    adminTitlingService
                        .getSourceCertificatesForADogSpecialty(dogId)
                        .then((res: any) => {
                            if (!isCurrentLoad()) return;
                            this.showResults = [];
                            this.filteredResults = [];
                            this.sourceCertificates = res;
                            this.filteredSourceCertificates = res;

                            loadingResults = false;
                            if (!calculatingCerts && !loadingResults && !loadingCerts) {
                                this.isLoading = false;
                            }
                        })
                        .catch((e: any) => {
                            if (isCurrentLoad()) this.handleLoadFailure(e);
                        });
                }

                this.getDogName(requestId, dogId, selectedCategory);
            },
            showError(message: string) {
                this.errorMessage = message;
                this.isError = true;
            },
            // Any failure while loading a program has to clear the overlay, or the page will become
            // stuck behind it with nothing to explain why.
            handleLoadFailure(e: any) {
                this.isLoading = false;
                this.showError(getErrorMessage(e));
            },
            filterResults(certId: any, ids: any) {
                this.filteredResults = this.showResults.filter((sr) =>
                    ids.includes(sr.resultId)
                );
                this.filteredCertificates = this.calculatedCertificates.filter((cert: any) =>
                    cert.title == certId
                );
            },
            filterCertificates(certId: any, ids: any) {
                this.filteredSourceCertificates = this.sourceCertificates.filter((cert) =>
                    ids.includes(cert.id)
                );
                this.filteredCertificates = this.calculatedCertificates.filter((cert: any) =>
                    cert.title == certId
                );
            },
            clearFilters() {
                this.filteredResults = this.showResults;
                this.filteredSourceCertificates = this.sourceCertificates;
                this.filteredCertificates = this.calculatedCertificates;
            },
            loadTitlesSelect(titleType: any) {
                this.resetUI();

                // A program cannot be loaded without a dog.
                if (titleType && !this.dogId) {
                    this.showError("Enter a dog ID before selecting a titling program.");
                    return;
                }

                if (titleType == "Rally")
                    this.loadtitles(this.getRallyTitlesForADogFn, 'R');
                if (titleType == "Obedience")
                    this.loadtitles(this.getObedienceTitlesForADogFn, 'O');
                if (titleType == "Stock")
                    this.loadtitles(this.getStockTitlesForADogFn, 'ST');
                if (titleType == "Agility")
                    this.loadtitles(this.getAgilityTitlesForADogFn, 'A');
                if (titleType == "Conformation")
                    this.loadtitles(this.getConformationTitlesForADogFn, 'C');
                if (titleType == "Tracking")
                    this.loadtitles(this.getTrackingTitlesForADogFn, 'T');
                if (titleType == "Farm Trial")
                    this.loadtitles(this.getFarmTrialTitlesForADogFn, 'FT');
                if (titleType == "Ranch Trial")
                    this.loadtitles(this.getRanchTrialTitlesForADogFn, 'RT');
                if (titleType == "Specialty")
                    this.loadtitles(this.getSpecialtyTitlesForADogFn, 'SP'); 
                if (titleType == "Scent Detection")
                    this.loadtitles(this.getScentDetectionTitlesForADogFn, 'SD');
                if (titleType == "Dock Jumping")
                    this.loadtitles(this.getDockJumpingTitlesForADogFn, 'DJ');
            },
            clearReviewData() {
                this.loadRequestId++;
                this.resetUI();
                this.allCertificates = [];
                this.calculatedCertificates = [];
                this.filteredCertificates = [];
                this.filteredResults = [];
                this.highlightedResults = [];
                this.showResults = [];
                this.sourceCertificates = [];
                this.filteredSourceCertificates = [];
                this.dogCertsInDB = [];
                this.selectedCategory = "";
                this.currentRTCHprogressionStatus = null;
                this.currentATCHprogressionStatus = null;
                this.currentACEprogressionStatus = null;
                this.currentOTCHprogressionStatus = null;
                this.currentOTCHOprogressionStatus = null;
                this.currentScchProgressionStatus = null;
                this.unusedAgilityPointsForTransfer = [];
                this.unappliedUtilityResults = [];
                this.resultsSelectedForTransfer = [];
                this.resultsSelectedForTitlePath = [];
                this.highlightRTCHresults = false;
                this.highlightOTCHresults = false;
                this.highlightOTCHOresults = false;
                this.highlightUnusedAgilityPoints = false;
                this.highlightScchMajorWins = false;
                this.highlightUnappliedUDResults = false;
                this.highlightResults = false;
                this.isLoading = false;
                this.dogName = "";
                this.generatedDogName = "";
            },
            loadSelectedDogReview() {
                if (!this.dogId || !this.titleKey) return;
                this.$navigate({ path: `/admin/titling/review/${this.titleKey}?dogId=${encodeURIComponent(this.dogId.trim())}` });
                this.loadTitlesSelect(this.titleKey);
            },
            csvExport: function (type: number) {
                if (!this.dogId) {
                    this.showError("Enter a dog ID before exporting.");
                    return;
                }
                let filename = this.dogId.trim() + "_" + this.titleKey + "_results.csv";
                let content = this.filteredResults;
                if (type != 1) {
                    filename = this.dogId.trim() + "_" + this.titleKey + "_certs.csv";
                    content = this.certificatesList;
                }
                downloadCsv(filename, content);
            },
            getDogName(requestId: number, dogId: string, selectedCategory: string) {
                const isCurrentLoad = () => requestId === this.loadRequestId
                    && dogId === this.dogId
                    && selectedCategory === this.selectedCategory;
                adminTitlingService.getGeneratedNameForDog(dogId)
                    .then((res: any) => {
                        if (isCurrentLoad()) this.generatedDogName = res.generatedDogName;

                    })
                    .catch((e: any) => {
                        if (isCurrentLoad()) this.$handleError(e);
                    });

                adminTitlingService.getNameForDog(dogId)
                    .then((res: any) => {
                        if (isCurrentLoad()) this.dogName = res.generatedDogName;

                    })
                    .catch((e: any) => {
                        if (isCurrentLoad()) this.$handleError(e);
                    });

            },
            applyObedienceUtilitiesToTitle(titlePath: string) {
                this.$store.dispatch("changeLoaderStatus", true);
                var resultsSelected = this.resultsSelectedForTitlePath.map(r => r.resultId);
                if (titlePath === '') {
                    resultsSelected = this.showResults.map(r => r.resultId);
                }
                adminTitlingService.applyUtilityResultsToTitle(this.dogId, titlePath, resultsSelected).then((res) => {
                    this.$store.dispatch("changeLoaderStatus", false);
                    this.loadTitlesSelect(this.$props.program);
                });
            },
            resetUI: function () {
                this.highlightUnappliedUDResults = false;
                this.allSelectedOb = false;
                this.unappliedSelectedOb = false;
                this.currentATCHprogressionStatus = false;
                this.currentRTCHprogressionStatus = false;
                this.currentACEprogressionStatus = false;
                this.currentScchProgressionStatus = false;
                this.allSelected = false;
                this.unusedSelected = false;
                this.errorMessage = '';
                this.isError = false;
            },

        },
       
        watch: {
            propsDogId: function(newValue, oldValue) {
                if (newValue === oldValue || newValue === this.dogId) return;
                this.dogId = newValue ?? null;
            },
            program: function(newValue, oldValue) {
                if (newValue === oldValue || newValue === this.titleKey) return;
                this.titleKey = newValue ?? null;
            },
            dogId: function(newValue, oldValue) {
                if (newValue === oldValue) return;
                this.clearReviewData();
                if (!newValue) {
                    const path = this.titleKey
                        ? `/admin/titling/review/${this.titleKey}`
                        : '/admin/titling/review';
                    this.$navigate({ path });
                    return;
                }
                if (this.titleKey) this.loadSelectedDogReviewDebounced();
            },
            titleKey: function(newValue, oldValue){
                if (newValue === oldValue) return;
                this.clearReviewData();
                if (!newValue) {
                    this.$navigate({ path: '/admin/titling/review', query: this.dogId ? { dogId: this.dogId } : undefined });
                    return;
                }
                if(this.dogId) this.loadSelectedDogReviewDebounced();
            },
            unusedSelected: function (newValue) {
               if(newValue){
                    var unusedPoints = this.unusedAgilityPointsForTransfer.map((r: any) => r.resultId);
                    var selected = this.showResults.filter(r => unusedPoints.includes(r.resultId));
                    this.resultsSelectedForTransfer = selected;
                } else {
                    this.resultsSelectedForTransfer = [];
                    
                }
            },
            unappliedSelectedOb: function (newValue) {
                this.resultsSelectedForTitlePath = [];
                if (newValue) {
                    this.resultsSelectedForTitlePath = this.unappliedUtilityResults;
                }
            },
            allSelected: function (newValue) {
                if(newValue){
                    this.resultsSelectedForTransfer = this.showResults;
                } else {
                    this.resultsSelectedForTransfer = [];
                    
                }
            },
            allSelectedOb: function (newValue) {
                this.resultsSelectedForTitlePath = [];
                if (newValue) {
                    this.resultsSelectedForTitlePath = this.showResults;
                }

            },
           
               
            
        },
        computed: {
            getRallyTitlesForADogFn(): Function {
                return adminTitlingService.getRallyTitlesForADog;
            },
            getObedienceTitlesForADogFn(): Function {
                return adminTitlingService.getObedienceTitlesForADog;
            },
            getAgilityTitlesForADogFn(): Function {
                return adminTitlingService.getAgilityTitlesForADog;
            },
            getStockTitlesForADogFn(): Function {
                return adminTitlingService.getStockTitlesForADog;
            },
            getConformationTitlesForADogFn(): Function {
                return adminTitlingService.getConformationTitlesForADog;
            },
            getTrackingTitlesForADogFn(): Function {
                return adminTitlingService.getTrackingTitlesForADog;
            },
            getFarmTrialTitlesForADogFn(): Function {
                return adminTitlingService.getFarmTrialTitlesForADog;
            },
            getRanchTrialTitlesForADogFn(): Function {
                return adminTitlingService.getRanchTrialTitlesForADog;
            },
            getSpecialtyTitlesForADogFn(): Function {
                return adminTitlingService.getSpecialtyTitlesForADog;
            },
            getScentDetectionTitlesForADogFn(): Function {
                return adminTitlingService.getScentDetectionTitlesForADog;
            },
            getDockJumpingTitlesForADogFn(): Function {
                return adminTitlingService.getDockJumpingTitlesForADog;
            },
            userInfo(): UserInfo {
                return this.$store.state.userInfo;
            },
            missingCertificates(): any[] {
                var calculatedCertsTitles = this.calculatedCertificates.map((c: any) => { return c.titleName; });
                var missingCerts = this.dogCertsInDB.filter((cert: any) => {
                    return !calculatedCertsTitles.includes(cert.title);
                });
                return missingCerts;
            },
            certificatesList(): any[] {
                var allCertificates = this.calculatedCertificates;
                allCertificates.forEach((cert: any) => {
                    cert.dbShowDate = this.getCertDBDate(cert.titleName);
                    cert.genDate = this.getCertGeneratedDBDate(cert.titleName);
                    cert.printDate = this.getCertPrintedDBDate(cert.titleName);
                });
                if (!!this.missingCertificates && this.missingCertificates.length > 0) {
                    this.missingCertificates.forEach(dbCert => {
                        allCertificates.push({
                            titleName: dbCert.title,
                            relatedResultsIds: [],
                            dbShowDate: this.getCertDBDate(dbCert.title),
                            genDate: this.getCertGeneratedDBDate(dbCert.title),
                            printDate: this.getCertPrintedDBDate(dbCert.title),
                        });
                    });
                }
                return allCertificates;
            },
          
        },
    });
</script>
